import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import faqData from '../../data/faq.json';
import FaqItem from './item';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Faq = () => {
  const [data, setData] = useState(faqData.faq);
  const [category, setCategory] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleClick = (ctg) => {
    setCategory(ctg);
    setData(faqData?.faq.filter((d) => d.category_id === ctg));
  };

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>FAQ | 株式会社TERRA</title>
      </Helmet>
      <div className="faq">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          よくあるご質問
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>よくあるご質問</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container m-auto">
          <div
            className="faq-content"
            style={{
              maxWidth: '1200px',
            }}
          >
            <div className="d-flex flex-wrap my-3 py-2 p-lg-4">
              {
                faqData.category.map((ctg) => (
                  <button
                    key={ctg.id}
                    style={{
                      height: '3rem',
                      lineHeight: '3rem',
                      backgroundColor: category === ctg.id ? 'rgb(44,81,115)' : 'rgb(126,166,186)',
                      color: 'white',
                      padding: '0 1.5rem',
                      marginRight: '2rem',
                      borderRadius: '1.5rem',
                      marginBottom: '1rem',
                    }}
                    onClick={() => handleClick(ctg.id)}
                    type="button"
                    className="btn"
                  >
                    {ctg.name}
                  </button>
                ))
             }
            </div>
            <div className="faq-list pb-5">
              {
                data.map((item) => (
                  <FaqItem key={item.id} question={item.question} answer={item.answer} />
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Faq;
